import { render } from "./SupportHistory.vue?vue&type=template&id=5ed71e28&scoped=true"
import script from "./SupportHistory.vue?vue&type=script&lang=js"
export * from "./SupportHistory.vue?vue&type=script&lang=js"

import "./SupportHistory.vue?vue&type=style&index=0&id=5ed71e28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed71e28"]])

export default __exports__